__turbopack_context__.v({
  "className": "inter_be5e63e2-module__QQUx8G__className",
});
